import taskEvents from "@/modules/tasks/events/events"
import eventHandlers from "@/modules/tasks/events/event-handlers"
import EventBus from "@/events/event-bus"

let _eventBus: Nullable<typeof EventBus> = null

function init(bus: typeof EventBus) {
  if (_eventBus) throw new Error("Task Module event bus has already been initialized!")
  _eventBus = bus
  registerEventListeners()
}

function registerEventListeners() {
  if (!_eventBus) return
  _eventBus.$on(taskEvents.TASKS_CHANGED, eventHandlers.handleTasksChanged)
}

function getBus(): typeof EventBus {
  if (!_eventBus) throw new Error("Task Module event bus has not yet been initialized, call init() first")
  return _eventBus
}

export default {
  init,
  getBus
}
